<script>
import { required, minValue, integer } from 'vuelidate/lib/validators';
import scrollMixin from '@/mixins/scrollWheelMixin';
import Repositories from '@/repositories';
const ItemsRepository = Repositories.get('items');
import Tooltip from '@/components/widgets/errors/validations-tooltip.vue';

export default {
  props: {
    item: { type: Object, required: true },
    showAvailables: { type: Boolean, default: true },
  },
  components: {
    Tooltip,
  },
  mixins: [scrollMixin],
  data() {
    return {
      mixins: [scrollMixin],
      totalQuantity: this.item.totalQuantity,

      metadataEdition: {
        isEditingQuantity: false,
        isLoadingEdition: false,
      },
    };
  },
  methods: {
    startEditingQuantity() {
      this.metadataEdition.isEditingQuantity = true;
      this.$nextTick(() => {
        this.$v.$reset();
        const editInput = this.$refs.editQuantityInput;
        editInput.focus();
      });
    },
    cancelEdition() {
      this.$v.$reset();
      this.metadataEdition.isEditingQuantity = false;
    },
    saveQuantity() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.metadataEdition.isLoadingEdition = true;
        ItemsRepository.actions
          .updateQuantity(
            { quantity: this.toFloat(this.totalQuantity) },
            this.item.idPublic
          )
          .then(() => {
            this.metadataEdition.isLoadingEdition = false;
            this.metadataEdition.isEditingQuantity = false;
            this.$emit('item-updated', {
              ...this.item,
              totalQuantity: this.totalQuantity,
            });
          })
          .catch((error) => {
            this.metadataEdition.isLoadingEdition = false;
            if (error.response.status == 409) {
              this.$toast.warningToast(
                this.$t('errors.wasDesyncedTryAgainBulk')
              );
              this.$emit('reload-item');
            } else {
              this.$toast.errorToast(this.$t('errors.errorLoading'));
            }
          });
      }
    },
    wheelInput(event) {
      this.totalQuantity = this.scrollMixinEvent(
        event,
        this.totalQuantity,
        this.item.totalQuantity - this.availableQuantity
      );
    },
    modifyQuantityModal() {
      this.$bvModal.show('modify-items-modal');
    },
  },
  computed: {
    availableQuantity() {
      if (this.item == null) return 0;

      return this.item.totalQuantity - this.item.reservedQuantity;
    },
  },
  validations() {
    if (this.item != null) {
      if (this.item.quantityType == 'unitary') {
        return {
          totalQuantity: {
            required,
            minValue: minValue(this.item.reservedQuantity),
            integer,
          },
        };
      } else {
        return {
          totalQuantity: {
            required,
            minValue: minValue(this.item.reservedQuantity),
          },
        };
      }
    } else {
      return {
        totalQuantity: { required, minValue: minValue(0) },
      };
    }
  },
  watch: {
    item() {
      this.totalQuantity = this.item.totalQuantity;
    },
  },
};
</script>

<template>
  <div v-if="item != null" class="flex-box">
    <div class="quantity-group">
      <h5>
        {{ $t('items.quantity') }}
      </h5>

      <div v-if="!metadataEdition.isEditingQuantity" class="quantity-number">
        <div>
          {{ item.totalQuantity }}
        </div>
        <i
          class="fas fa-pencil-alt text-primary pl-2 pr-2"
          @click="startEditingQuantity"
          style="cursor: pointer; font-size: 1.2em"
        ></i>
      </div>
      <div v-else class="quantity-number" style="position: relative">
        <b-input
          :class="{
            'is-invalid': $v.totalQuantity.$error,
          }"
          ref="editQuantityInput"
          v-model="totalQuantity"
          style="font-size: 1.1em; max-width: 150px"
          @wheel.prevent="wheelInput($event)"
          @keydown.escape.prevent.stop="cancelEdition"
          @keydown.enter.prevent="saveQuantity"
          type="text"
        ></b-input>
        <Tooltip :validations="$v.totalQuantity" />

        <i
          id="popover-button"
          :class="
            metadataEdition.isLoadingEdition
              ? 'fas fa-spinner fa-spin text-warning ml-3 mr-2'
              : 'fas fa-check text-success pl-3 pr-2'
          "
          @click="saveQuantity"
          style="cursor: pointer; font-size: 1.5em"
        ></i>
      </div>
    </div>

    <div class="quantity-group">
      <h5>
        {{ $t('items.reserved') }}
      </h5>
      <div class="quantity-number">
        {{ item.reservedQuantity }}
      </div>
    </div>

    <div v-if="showAvailables" class="quantity-group">
      <h5>
        {{ $t('items.availables') }}
      </h5>
      <div class="quantity-number">
        {{ availableQuantity }}
      </div>
    </div>
  </div>
</template>

<style scoped>
h5 {
  margin-bottom: 0;
}
.quantity-number {
  display: flex;
  height: 40px;
  align-items: center;
  font-size: 1.1em;
}
.quantity-group {
  margin-right: 20px;
}
</style>